let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aZd3F")).then(() => parcelRequire('cu1Rj'));